import React from 'react'
import AOSInit from '../../components/Animation/AOSInit'
import NavBarHome from '../../components/NavBar/NavBarHome'
import AnimatedSection from '../../components/Animation/AnimatedSection'
import Masthead from './Masthead'
import Footer from '../../components/Footer/Footer'
import UniqueLearningAdventure from './UniqueLearningAdventure'
import FeaturedCourses from './FeaturesCourses'
import LittleMakerMethodology from './LittleMakerMethodology'
import Avantages from './Avantages'
import Testimonials from './Testimonials'
import PracticalinformationRegistration from './PracticalinformationRegistration'

function HomeLittleMaker() {
  return (
    <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
      <AOSInit />
      <NavBarHome />

      {/* Hero Section */}
      <section id="hero" className="relative ">
        <AnimatedSection
          animation="fade-up"
          duration={1200}
          delay={100}
          threshold={1.0}
        >
          <Masthead />
        </AnimatedSection>
      </section>

      {/* A Unique Learning Adventure */}
      <section id="unique-learning-adventure" className="">
        <AnimatedSection
          animation="fade-up"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <UniqueLearningAdventure />
        </AnimatedSection>
      </section>

      {/* Pricing */}
      <section id="pricing" className="">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <FeaturedCourses />
        </AnimatedSection>
      </section>

      {/* Little Maker Methodology */}
      <section id="little-maker-methodology" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <LittleMakerMethodology />
        </AnimatedSection>
      </section>

      {/* Avantages */}
      <section id="avantages" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <Avantages />
        </AnimatedSection>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <Testimonials />
        </AnimatedSection>
      </section>

      {/* PracticalinformationRegistration */}
      <section id="practicalinformationregistration" className="">
        <AnimatedSection
          animation="fade-down"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <PracticalinformationRegistration />
        </AnimatedSection>
      </section>

      {/* Recommendations */}
      {/* <section id="recommendations">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <JoinLearners />
        </AnimatedSection>
      </section> */}

      {/* Footer */}
      <section id="footer">
        <Footer
          logo={"/general/logo-pure-white.svg"}
          bgColor="bg-[#140342]"
          textColor="text-gray-100"
          borderColor="border-gray-400/20"
        />
      </section>
    </div>
  )
}

export default HomeLittleMaker